module.exports = __webpack_public_path__ + "static/media/3.45a8ca14.jpg";